//converts Sentence casing into camelCasing 
export const toCamelCase = (str = "") =>
  str
    .trim()
    .split(/[\s_\-]+/)
    .filter(Boolean)
    .map((word, index) => {
      const lower = word.toLowerCase();
      return index === 0 ? lower : lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join("");